import { render, staticRenderFns } from "./PatientOperationsList.vue?vue&type=template&id=6e00b193&"
import script from "./PatientOperationsList.vue?vue&type=script&lang=js&"
export * from "./PatientOperationsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports